import styled from "styled-components";

export const TertiaryButtonText = styled.span`
  font-size: 16px;
  font-weight: normal;
`;

export const TertiaryButton = styled.button`
  color: var(--ons-color-ocean-blue);
  border-radius: 3px;
  border: 2px solid #6390b5;
  background-color: var(--ons-color-white);
  padding: 2px 6px;

  &:hover {
    background-color: var(--ons-color-grey-15);
    cursor: pointer;
  }

  &:focus {
    border: 2px solid var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
    color: var(--ons-color-black);
  }
`;
